<div class="page_title">
  <div class="container-fluid">
    <div class="row">
      <div class="col-auto" *ngIf="this.claimId">
        <k-button [type]="KButtonType.KLAiMSButton" [label]="'Back'" [color]="'brand-main'"
          [icon]="{type: 'kennedys', name: 'back-arrow'}" (buttonClick)="goToPage()">
        </k-button>
      </div>
      <div class="col mt-1">
        <app-custom-breadcrumb *ngIf="customData" [data]="customData"></app-custom-breadcrumb>
      </div>
    </div>
  </div>
</div>


<div class="container-fluid">
  <div class="pages_space">


    <div class="report_wrap">
      <div class="left_section  cardSectionSpace">
        <k-card [card]="claimInfo" *ngIf="claimData"></k-card>
        <div class="row">
          <div class="col-8">
            <button (click)="gotoAudiometryForm()" type="button"
              class="btn-brand-main btn-block klaim_btn text-center mb-3 w-100">Audiometry Values</button>
          </div>
          <div class="col-4">
            <button (click)="saveAudiogramParams()" type="button"
              class="btn-brand-main btn-block klaim_btn text-center mb-3 w-100">Save</button>
          </div>
        </div>
        <k-card [card]="claimInfo2" *ngIf="claimData"></k-card>
        <div class="audioInfoBox audioInfoBox_2">
          <app-modifier (modifierUpdated)="modifierUpdated($event)" [audiometryInput]="audiometryIn"
            [presetFilters]="presetFilters" [ageCentile]="ageCentile"></app-modifier>
        </div>
      </div>
      <div class="main_section">
        <div class=" plot_box mb-3">
          <app-filter [instanceId]="instanceId" (filterChange)="filterChange($event)"
            [plotFilter]="plotFilter"></app-filter>
        </div>
        <div class="audioInfoBox graph_box">
          <app-chart [dataset]="lines" [enable-save-button]="true" (onSave)="saveChartToImage()"></app-chart>
        </div>
        <div class="audioInfoBox table_box table_EarData tbl_lod_ani borderBottom" *ngIf="rightEarData && leftEarData">
          <app-table name="Right" [tdh39Amendment]="tdh39Amendment" [loading]="loader"
            [data]="rightEarData.table"></app-table>
          <app-table name="Left" [tdh39Amendment]="tdh39Amendment" [loading]="loader"
            [data]="leftEarData.table"></app-table>
        </div>
        <div class="airConductionSymmetryBox mt-3 borderBottom">
          <h5>Air Conduction Symmetry</h5>
          <div class="text_align" *ngIf="airCondSymmetries.length <= 0">
            <p>No asymmetries recorded</p>
          </div>
          <div class="airConductionValue" *ngIf="airCondSymmetries.length > 0">
            <div class="row mt-3">
              <div class="col-md-6" *ngFor="let symm of airCondSymmetries">
                <div class="row">
                  <div class="col-md-4">
                    <k-card [card]="symm"></k-card>
                  </div>
                  <div class="col-md-8 symm_text_container">
                    <p class="text">{{symm.value}}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="highFrequencySymmetryBox mt-3 borderBottom">
          <h5>R1-High Frequency Impairment</h5>
          <div class="highFrequencyValue">
            <div class="row mt-3">
              <div class="col-md-6" *ngFor="let highFreqEar of highFrequencyImpairment">
                <div class="row">
                  <div class="col-md-4">
                    <k-card [card]="highFreqEar"></k-card>
                  </div>
                  <div class="col-md-8 symm_text_container">
                    <p class="text">{{highFreqEar.value}}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="noiseImmisionLevel mt-3">
          <h5>Noise Immision Level and Audiometric Configuration</h5>

          <!-- 1st Row: Notch Evaluation Summary -->
          <div class="row mt-3">
            <div class="col-md-6" *ngFor="let notchEvaluation of notchEvaluationLevel">
              <div class="row">
                <div class="col-md-4">
                  <k-card [card]="notchEvaluation"></k-card>
                </div>
                <div class="col-md-8 symm_text_container">
                  <p class="text">{{notchEvaluation.value}}</p>
                </div>
              </div>
            </div>
          </div>

          <!-- 2nd Row: Notch - Left and Right -->
          <div class="row mt-3">
            <div class="col-md-6" *ngFor="let notchEar of notchEvaluationEars">
              <div class="row">
                <div class="col-md-4">
                  <k-card [card]="notchEar"></k-card> <!-- Left and Right Ear Notch Cards -->
                </div>
                <div class="col-md-8 symm_text_container">
                  <p class="text">{{notchEar?.value}}</p>
                </div>
              </div>
            </div>
          </div>

          <!-- 3rd Row: Bulge - Left and Right -->
          <div class="row mt-3">
            <div class="col-md-6" *ngFor="let bulgeEar of bulgeEvaluationEars">
              <div class="row">
                <div class="col-md-4">
                  <k-card [card]="bulgeEar"></k-card> <!-- Left and Right Ear Bulge Cards -->
                </div>
                <div class="col-md-8 symm_text_container">
                  <p class="text">{{bulgeEar?.value}}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <k-simple-alert [display]="displaySuccess" [msgType]="'success'" [message]="successText"
    [timeout]="timeout"></k-simple-alert>
  <k-simple-alert [display]="displayError" [msgType]="'error'" [message]="errorText"
    [timeout]="timeout"></k-simple-alert>
  <k-simple-alert [display]="displayWarning" [msgType]="'warning'" [message]="warningText"
    [timeout]="timeout"></k-simple-alert>